/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.conditional.properties.rpc.ConditionalPropertiesUnifiedRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getRulesRpc = {
  serviceName: 'com.hubspot.conditional.properties.rpc.ConditionalPropertiesUnifiedRpc',
  rpcName: 'getRules',
  auth: 'app',
  fingerprint: 'n0jmfmBOycbUUkZpNcadrZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};